// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2vXpI","dragIcon":"SortableItem_dragIcon__1rPKZ","disabled":"SortableItem_disabled__WTgEW"};